/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilters_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuDrawerAppliedFilterDisplay_itemSearch" | "SbRespRefineMenuFilterPrice_itemSearch" | "SbSharedRefineMenuFilterStone_itemSearch" | "SbSharedRefineMenuFilterMetal_itemSearch" | "SbSharedRefineMenuFilterColor_itemSearch" | "SbMobileRefineMenuFilterPrice_itemSearch" | "SbSharedRefineMenuFilterStyle_itemSearch" | "SbSharedRefineMenuFilterOrigin_itemSearch" | "SbSharedRefineMenuFilterPeriod_itemSearch" | "SbRespRefineMenuFilterCategory_itemSearch" | "SbRespRefineMenuFilterStoneCut_itemSearch" | "SbSharedRefineMenuFilterCreator_itemSearch" | "SbMobileRefineMenuFilterStoneCut_itemSearch" | "SbMobileRefineMenuFilterCategory_itemSearch" | "SbSharedRefineMenuFilterMaterial_itemSearch" | "SbRespRefineMenuFilterDeliveryOptions_itemSearch" | "SbMobileRefineMenuFilterDeliveryOptions_itemSearch" | "SbSharedRefineMenuFilterItemType_itemSearch" | "SbRespRefineMenuFilterDimensions_itemSearch" | "SbRespRefineMenuFilterCaratWeight_itemSearch" | "SbMobileRefineMenuFilterDimensions_itemSearch" | "SbMobileRefineMenuFilterCaratWeight_itemSearch" | "SbSharedRefineMenuFilterAvailability_itemSearch" | "SbSharedRefineMenuFilterMatchingSets_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilters_itemSearch";
};
export type SbSharedRefineMenuFilters_itemSearch$data = SbSharedRefineMenuFilters_itemSearch;
export type SbSharedRefineMenuFilters_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilters_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilters_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilters_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displayName",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuDrawerAppliedFilterDisplay_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStone_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMetal_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterColor_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterPrice_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStyle_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterOrigin_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterPeriod_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterCategory_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterStoneCut_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterCreator_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterStoneCut_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterCategory_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMaterial_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDeliveryOptions_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDeliveryOptions_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterItemType_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterCaratWeight_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDimensions_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterCaratWeight_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterAvailability_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMatchingSets_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '9a3171d508241eeb6adaed804e34dcb2';
export default node;
